<template>
  <div>
    <div class="titleBloc d-flex flex-column justify-content-center">
      <div class="title">{{ ratesLg[currentLg].settings.rates_extratitle }}</div>
    </div>
    <div id="rates" class="d-flex flex-column justify-content-top align-items-left" v-if='ratesLg'>
        <div id="header" class="d-flex flex-row justify-content-end align-items-center">
            <div class="title" v-html="ratesLg[currentLg].periodTitle.period1"></div>
            <div class="title" v-html="ratesLg[currentLg].periodTitle.period2"></div>
        </div>
        <div id="rows" class="d-flex flex-column justify-content-around align-items-end justify-content-center">
            <row class="rowa" v-for="(rates, index) in ratesLg[currentLg].rates2" :key="index" :ratesLg1='rates' :ratesLg2='ratesLg.lg2 && ratesLg.lg2.rates2[index]'></row>
        </div>
        <legalNoticeLeft :legalNoticeLg="legalNoticeLg" :currentLg="currentLg"></legalNoticeLeft>
    </div>
  </div>
</template>

<script>
import Row from './rowRates'
import LegalNoticeLeft from './legalNoticeLeft'

export default {
  components: {
    row: Row,
    'legalNoticeLeft': LegalNoticeLeft
  },
  name: 'IbisRatesHorizontalV1Rates',
  props: {
    ratesLg: Object,
    currentLg: ''
  },
  computed: {
    legalNoticeLg () {
      return {lg1: this.ratesLg.lg1.settings.roomRate_footer && this.ratesLg.lg1.settings.roomRate_footer.replace(/\r\n/g, '<br>'), lg2: this.ratesLg.lg2 && this.ratesLg.lg2.settings.roomRate_footer.replace('\r\n', '<br>')}
    }
  }
}
</script>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibis.scss";

#rates {
  width: 100%;
  height: 100%;

  #header {
    width: 100%;
    @include heightPercent(103);
    text-align: right;
    font-family: "Neutraface-Bold";
    @include fontSize(24);
    color: $red;
    padding-top: 2vh;

    .title {
        @include widthPercent(230);
    }
  }

  #rows {
    width: 100%;
    border-bottom: 1px solid $border;

    .rowa:nth-of-type(n+6){
      display:none!important;
    }
  }
}

</style>

<style lang="scss" scoped>
$srcWidth: 1920;
$srcHeight: 1200;
@import "../../../../_ibis.scss";

.titleBloc {
  position: absolute;
  @include topPercent(240);
  @include heightPercent(40);
  font-family: "Neutraface-Bold";
  text-transform: uppercase;
  font-feature-settings: "case";

  .title {
      @include fontSize(24);
      color: $red;
      padding-top: 2vh;
  }

}
</style>


// WEBPACK FOOTER //
// src/components/ibis/rates/horizontal/v1/rates/rates.vue